/**
 * @desc 移除货件分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.removalShipmentPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/removalShipmentPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
